import Size from './Cordinates/Size.js';
import Point from './Cordinates/Point.js';

export default {
    BASE_ELEMENT: 'basic_element',
    EXTRA_ELEMENT: 'accessories',
    CONNECTOR_ELEMENT: 'connectors',
    TEXT_ELEMENT: 'text',

    ORIENTATION_LEFT: 'left',
    ORIENTATION_RIGHT: 'right',
    ORIENTATION_TOP: 'top',
    ORIENTATION_BOTTOM: 'bottom',

    RULESET_SINGLE_ELEMENT: 'single_element',
    RULESET_DOUBLE_ELEMENT: 'double_element',
    RULESET_SIDE_BUMPER: 'side_bumper',
    RULESET_SIDE_BUMPER_3: 'side_bumper_3',
    RULESET_SIDE_BUMPER_4: 'side_bumper_4',
    RULESET_SIDE_BUMPER_5: 'side_bumper_5',
    RULESET_SIDE_BUMPER_6: 'side_bumper_6',
    RULESET_SIDE_BUMPER_7: 'side_bumper_7',
    RULESET_STEPS: 'ladder',
    RULESET_CONNECTOR: 'connector',
    RULESET_CORNER_BUMPER_1: 'corner_bumper_1',

    ELEMENT_SIZES: {
        "single_element": new Size(1, 1),
        "double_element": new Size(1, 2),
        "ladder": new Size(1, 1),
        "side_bumper": new Size(1, 1.7),
        "side_bumper_3": new Size(1, 2.7),
        "side_bumper_4": new Size(1, 3.7),
        "side_bumper_5": new Size(1, 4.7),
        "side_bumper_6": new Size(1, 5.7),
        "side_bumper_7": new Size(1, 7.3),
        "connector": new Size(0.3, 0.3),
        "corner_bumper_1": new Size(0.5, 0.5),
    },

    ELEMENT_CONNECTIONS: {
        "single_element": [
            {
                cords: new Point(0, 0),
                level: 3,
                extends: ["rb"],
            },
            {
                cords: new Point(1, 0),
                level: 2,
                extends: ["lb"],
            },
            {
                cords: new Point(0, 1),
                level: 4,
                extends: ["rt"],
            },
            {
                cords: new Point(1, 1),
                level: 1,
                extends: ["lt"],
            },
        ],
        "double_element": [
            {
              cords: new Point(0, 0),
              level: 3,
              extends: ["rb"],
            },
            {
              cords: new Point(1, 0),
              level: 2,
              extends: ["lb"],
            },
            {
              cords: new Point(0, 1),
              level: 4,
              extends: ["rt", "rb"],
            },
            {
              cords: new Point(1, 1),
              level: 1,
              extends: ["lt", "lb"],
            },
            {
              cords: new Point(0, 2),
              level: 4,
              extends: ["rt"],
            },
            {
              cords: new Point(1, 2),
              level: 1,
              extends: ["lt"],
            },
        ],
        "ladder": [
            {
              cords: new Point(0, 0),
              level: 3,
              extends: ["rb"],
            },
            {
              cords: new Point(1, 0),
              level: 2,
              extends: ["lb"],
            },
            {
              cords: new Point(0, 1),
              level: 4,
              extends: ["rt"],
            },
            {
              cords: new Point(1, 1),
              level: 1,
              extends: ["lt"],
            },
        ],
        "side_bumper": [
            {
              cords: new Point(0, 0),
              level: 3,
              extends: ["rb"],
            },
            {
              cords: new Point(1, 0),
              level: 2,
              extends: ["lb"],
            },
            {
              cords: new Point(0, 1),
              level: 4,
              extends: ["rt"],
            },
            {
              cords: new Point(1, 1),
              level: 1,
              extends: ["lt"],
            },
        ],
        "side_bumper_3": [
          {
            cords: new Point(0, 0),
            level: 3,
            extends: ["rb"],
          },
          {
            cords: new Point(1, 0),
            level: 2,
            extends: ["lb"],
          },
          {
            cords: new Point(0, 1),
            level: 4,
            extends: ["rt"],
          },
          {
            cords: new Point(1, 1),
            level: 1,
            extends: ["lt"],
          },
          {
            cords: new Point(0, 2),
            level: 4,
            extends: ["rt"],
          },
          {
            cords: new Point(1, 2),
            level: 1,
            extends: ["lt"],
          },
        ],
        "side_bumper_4": [
          {
            cords: new Point(0, 0),
            level: 3,
            extends: ["rb"],
          },
          {
            cords: new Point(1, 0),
            level: 2,
            extends: ["lb"],
          },
          {
            cords: new Point(0, 1),
            level: 4,
            extends: ["rt"],
          },
          {
            cords: new Point(1, 1),
            level: 1,
            extends: ["lt"],
          },
          {
            cords: new Point(0, 2),
            level: 4,
            extends: ["rt"],
          },
          {
            cords: new Point(1, 2),
            level: 1,
            extends: ["lt"],
          },
          {
            cords: new Point(0, 3),
            level: 4,
            extends: ["rt"],
          },
          {
            cords: new Point(1, 3),
            level: 1,
            extends: ["lt"],
          },
      ],
      "side_bumper_5": [
        {
          cords: new Point(0, 0),
          level: 3,
          extends: ["rb"],
        },
        {
          cords: new Point(1, 0),
          level: 2,
          extends: ["lb"],
        },
        {
          cords: new Point(0, 1),
          level: 4,
          extends: ["rt"],
        },
        {
          cords: new Point(1, 1),
          level: 1,
          extends: ["lt"],
        },
        {
          cords: new Point(0, 2),
          level: 4,
          extends: ["rt"],
        },
        {
          cords: new Point(1, 2),
          level: 1,
          extends: ["lt"],
        },
        {
          cords: new Point(0, 3),
          level: 4,
          extends: ["rt"],
        },
        {
          cords: new Point(1, 3),
          level: 1,
          extends: ["lt"],
        },
        {
          cords: new Point(0, 4),
          level: 4,
          extends: ["rt"],
        },
        {
          cords: new Point(1, 4),
          level: 1,
          extends: ["lt"],
        },
      ],
      "side_bumper_6": [
        {
          cords: new Point(0, 0),
          level: 3,
          extends: ["rb"],
        },
        {
          cords: new Point(1, 0),
          level: 2,
          extends: ["lb"],
        },
        {
          cords: new Point(0, 1),
          level: 4,
          extends: ["rt"],
        },
        {
          cords: new Point(1, 1),
          level: 1,
          extends: ["lt"],
        },
        {
          cords: new Point(0, 2),
          level: 4,
          extends: ["rt"],
        },
        {
          cords: new Point(1, 2),
          level: 1,
          extends: ["lt"],
        },
        {
          cords: new Point(0, 3),
          level: 4,
          extends: ["rt"],
        },
        {
          cords: new Point(1, 3),
          level: 1,
          extends: ["lt"],
        },
        {
          cords: new Point(0, 4),
          level: 4,
          extends: ["rt"],
        },
        {
          cords: new Point(1, 4),
          level: 1,
          extends: ["lt"],
        },
        {
          cords: new Point(0, 5),
          level: 4,
          extends: ["rt"],
        },
        {
          cords: new Point(1, 5),
          level: 1,
          extends: ["lt"],
        },
      ],
    }
};
